// extracted by mini-css-extract-plugin
export default {"root":"xCi2f0YH","preview":"lM2usrZU"};